import { APICallV3Get } from 'reactApp/api/APICall';

class PromoListAPICall extends APICallV3Get {
    _method = 'promo/list';
}

export { PromoListAPICall };
